import script from "./QuickpaySettingsFaq.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsFaq.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsFaq.vue?vue&type=style&index=0&id=6c9349a3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9349a3"]])

export default __exports__